const config = {
  env: "local",
  // apiUrl: "http://localhost:8000/admin/",
  // apiUrl: "http://103.180.236.204:8500/admin/",
  
  apiUrl: "https://api.aerosystemindia.com/admin/",

  // apiUrl: "https://392q0kfx-8000.inc1.devtunnels.ms/admin/",
};

export default config;
